import { render, staticRenderFns } from "./SingleBayCell.vue?vue&type=template&id=220b1813&scoped=true"
import script from "./SingleBayCell.vue?vue&type=script&lang=ts"
export * from "./SingleBayCell.vue?vue&type=script&lang=ts"
import style0 from "./SingleBayCell.vue?vue&type=style&index=0&id=220b1813&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220b1813",
  null
  
)

export default component.exports